module.exports = __webpack_public_path__ + "img/mt.dac11acf.svg";